import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './modules/main/main.component';
import { FindPCPComponent } from './modules/main/components/findpcp/findpcp.component';
import { SearchComponent } from './modules/search/search.component';
import { SearchDetailsComponent } from './modules/searchdetails/search-details.component';
import { SignInRedirectComponent } from './components/sign-in-redirect/sign-in-redirect.component';
import { AuthGuard } from './guards/auth.guard';
import { OptionalAuthGuard } from './guards/optional-auth.guard';
import { LoginRedirectGuard } from './guards/login-redirect.guard';
import { MedicationComponent } from './modules/medication/medication.component';
import { RedirectSearchComponent } from './modules/redirect/components/redirect-search/redirect-search.component';

const routes: Routes = [
  { path: '', redirectTo: 'find', pathMatch: 'full' },
  { path: 'browse', component: MainComponent },
  { path: 'find', component: MainComponent, canActivate: [OptionalAuthGuard] },
  { path: 'employergroup', component: MainComponent },
  { path: 'findpcp', component: FindPCPComponent, canActivate: [AuthGuard] },
  { path: 'authority-client-login', component: LoginRedirectGuard, canActivate: [LoginRedirectGuard] },
  { path: 'search', component: SearchComponent },
  { path: 'prefiltered', component: RedirectSearchComponent, canActivate: [AuthGuard] },
  { path: 'searchdetails', redirectTo: 'browse' },
  { path: 'searchdetails/:type/:id/:networkid', component: SearchDetailsComponent },
  { path: 'searchdetails/:type/:id/:networkid/:location', component: SearchDetailsComponent},
  { path: 'provider-directory-login-redirect', component: SignInRedirectComponent },
  { path: 'medication', component: MedicationComponent},
  { path: 'providerdirectoryapp/find', redirectTo: 'find' },
  { path: 'providerdirectoryapp/search', redirectTo: 'search' },
  { path: 'providerdirectoryapp/searchdetails/:type/:id/:networkid', redirectTo: 'searchdetails/:type/:id/:networkid' },
  { path: 'ProviderDirectoryApp/find', redirectTo: 'find' },
  { path: 'ProviderDirectoryApp/search', redirectTo: 'search' },
  { path: 'ProviderDirectoryApp/searchdetails/:type/:id/:networkid', redirectTo: 'searchdetails/:type/:id/:networkid' },
  { path: '**', redirectTo: 'find' }
];

@NgModule({
  imports: [
    CommonModule, RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', anchorScrolling: 'enabled'})
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
